// components/ui/HoneypotField.tsx
import React from 'react';
import { HONEYPOT_FIELD } from '../../utils/spamGate';

/**
 * A decoy input that is invisible to people and irresistible to form-filling
 * bots. Anything that arrives with a value here was not typed by a human.
 *
 * Positioned off-screen rather than display:none on purpose. Better bots skip
 * hidden inputs, but most still fill anything the layout engine reports as
 * present, so off-screen catches more of them than display:none does.
 *
 * aria-hidden and tabIndex keep it out of the path of screen readers and
 * keyboard navigation, so it costs real visitors nothing.
 */
const HoneypotField: React.FC = () => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: '-9999px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
    }}
  >
    <label htmlFor={HONEYPOT_FIELD}>Website (leave this field empty)</label>
    <input
      type="text"
      id={HONEYPOT_FIELD}
      name={HONEYPOT_FIELD}
      tabIndex={-1}
      autoComplete="off"
      defaultValue=""
    />
  </div>
);

export default HoneypotField;
